import React, { useCallback, useRef, useState } from 'react';
import BrandTaxConsentDialog from '../components/brand-deal/brand-tax-consent-dialog';
import { isBrandTaxConsentError } from '../utils/brand-tax';

/**
 * Bốn nút nhận việc của creator dùng chung: payment trả BRAND_TAX_CONSENT_REQUIRED ⇒ mở hộp điều khoản thuế; đồng ý xong tự chạy
 * lại đúng thao tác vừa bấm một lần; đóng hộp thì thôi.
 * Dùng: const taxConsent = useBrandTaxConsent();
 *   - trong catch: if (taxConsent.handle(err, () => doAction(sameArgs))) return;
 *   - render: {taxConsent.dialog}
 */
export function useBrandTaxConsent() {
  const [open, setOpen] = useState(false);
  const retryRef = useRef<null | (() => void)>(null);

  const handle = useCallback((err: unknown, retry: () => void): boolean => {
    if (!isBrandTaxConsentError(err)) return false;
    retryRef.current = retry;
    setOpen(true);
    return true;
  }, []);

  const dialog = (
    <BrandTaxConsentDialog
      open={open}
      onClose={() => {
        retryRef.current = null;
        setOpen(false);
      }}
      onDone={() => {
        const retry = retryRef.current;
        retryRef.current = null;
        setOpen(false);
        if (retry) retry();
      }}
    />
  );

  return { handle, dialog };
}
